import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function DevExRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month DevEx Career Roadmap`}
      subtitle="Developer Experience Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-devex-roadmap.pdf"
      roleKey={roleKey || "devex"}
    />
  );
}

